export default __webpack_public_path__ + "static/song-bg1@2x-528f9262d5bd086beb2b9e7b712f3f48.jpg";